import React, { FC } from "react";
import ClickableIframe from "@src/lib/ui/ClickableIframe";
import Text from "@src/lib/ui/Text";
import PromptMediaFileAndLinkContainer from "@src/features/libraryItem/course/PromptMediaFileAndLinkContainer";
import Spacer from "@src/lib/ui/Spacer";
import useBrandColor from "@src/features/settings/hooks/useBrandColor";
import ShowViewButtonOverlay from "./ShowViewButtonOverlay";
import { addOpacityToHexColor } from "@src/lib/utils/color";
import ClickablePdfPreview, { PDF_WIDTH } from "./ClickablePdfPreview";

type Props = {
  mediaUrl: string;
  title?: string;
  clickableIframeProps?: Partial<React.ComponentProps<typeof ClickableIframe>>;
  showViewButton?: boolean;
};

const PromptMediaPdfPreview: FC<Props> = (props) => {
  const brandColor = useBrandColor();

  return (
    <PromptMediaFileAndLinkContainer
      overlayContent={
        props.showViewButton ? (
          <ShowViewButtonOverlay url={props.mediaUrl} buttonPosition="center" />
        ) : null
      }
      centerContent={
        <div className="flex flex-col items-center">
          <div
            className="flex items-center justify-center overflow-hidden rounded-2xl"
            style={{
              aspectRatio: "128 / 180",
              width: PDF_WIDTH,
              filter: `drop-shadow(0px 0px 3.58904px ${addOpacityToHexColor(
                brandColor,
                0.5,
              )}) drop-shadow(0px 7.17809px 54.36px ${addOpacityToHexColor(
                brandColor,
                0.5,
              )})`,
            }}
          >
            <ClickablePdfPreview
              mediaUrl={props.mediaUrl}
              clickableIframeProps={props.clickableIframeProps}
            />
          </div>
          <Spacer size={24} />
          <Text type={"H3"} fontWeight={"SemiBold"} color={brandColor}>
            {props.title || "PDF"}
          </Text>
        </div>
      }
    />
  );
};

export default PromptMediaPdfPreview;
